export default "__VITE_ASSET__DNB2kS_x__"